<template>
  <div>
    <el-container>
      <el-main>
        <el-row>
          <el-col :span="24">
            <!-- <ReportByProductByMonthFilters
              @onYearSelected="OnYearSelected"
              @thecnicianChaged="OnThecnicianChaged"
              @customerServiceChanged="OnCustomerServiceChanged"
              @resquestTypeChanged="OnRequestTypeChanged"
            /> -->
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <InternalRequestByModuleMonthlyReportTable />
            <!-- <ReportByModuleByMonthTable
              :yearSelected="yearSelected"
              :thecnicianSelected="thecnicianSelected"
              :customerServiceCode="customerServiceCode"
              :requestTypeSelected="requestTypeSelected"
              @OpeningDetailDialosg="OnDetailDialogOpen"
            /> -->
          </el-col>
        </el-row>
        <!-- <MonthlyRequstsByModulesReportDetail
          :DialoVisible="detailDialogVisible"
          :YearSelected="yearSelected"
          :ThecnicianSelected="thecnicianSelected"
          :CustomerServiceCode="customerServiceCode"
          :Month="monthSelected"
          :ModuleId="moduleId"
          :ModuleName="moduleName"
          :RequestTypeSelected="requestTypeSelected"
          @ClosingDialog="OnDetailDialogClose"
        /> -->
      </el-main>
    </el-container>
  </div>
</template>

<script>
import InternalRequestByModuleMonthlyReportTable from "@/components/internal_requests/reports/InternalRequestByModuleMonthlyReport/InternalRequestByModuleMonthlyReportTable";
export default {
  name: "InternalRequestByModuleMontlyReport",
  components: {
    InternalRequestByModuleMonthlyReportTable
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style scoped></style>
